import { ScrollingModule as ExperimentalScrollingModule } from '@angular/cdk-experimental/scrolling';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ColorPickerModule } from 'ngx-color-picker';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

// Modules
import { PipesModule } from '../pipes/pipes.module';
import { ProtocolDroidModule } from '../services/protocol-droid/protocol-droid.module';
import { SvgIconModule } from './components/svg-icon/svg-icon.module';

// Components
import { AlertWarningComponent } from './components/alert/alert.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { BadgeErrorsComponent } from './components/badge-errors/badge-errors.component';
import { BadgeInfosComponent } from './components/badge-infos/badge-infos.component';
import { BadgeComponent } from './components/badge/badge.component';
import { BoxDashComponent } from './components/box-dash/box-dash.component';
import { ButtonCopyComponent } from './components/button-copy/button-copy.component';
import { ButtonFlashingComponent } from './components/button-flashing/button-flashing.component';
import { ButtonIconComponent } from './components/button-icon/button-icon.component';
import { ButtonRoundComponent } from './components/button-round/button-round.component';
import { CaretComponent } from './components/caret/caret.component';
import { ConversationAiSourcesComponent } from './components/conversation-data/conversation-ai-sources/conversation-ai-sources.component';
import { ConversationDataListComponent } from './components/conversation-data/conversation-data-list/conversation-data-list.component';
import { ConversationDataComponent } from './components/conversation-data/conversation-data.component';
import { ConversationIntroComponent } from './components/conversation-data/conversation-intro/conversation-intro.component';
import { DataComparisonListComponent } from './components/data-comparison-list/data-comparison-list.component';
import { DataComparisonTypeSelectorComponent } from './components/data-comparison/data-comparison-type-selector/data-comparison-type-selector.component';
import { DataComparisonComponent } from './components/data-comparison/data-comparison.component';
import { DataKeysBadgeComponent } from './components/data-keys-badge/data-keys-badge.component';
import { DataKeysDropdownMenuListComponent } from './components/data-keys-dropdown-menu-list/data-keys-dropdown-menu-list.component';
import { DataSingleValueSelectorComponent } from './components/data-single-value-selector/data-single-value-selector.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { FilterBadgeComponent } from './components/filter-badge/filter-badge.component';
import { HeaderAppDropdownComponent } from './components/header-app-dropdown/header-app-dropdown.component';
import { InputTextComponent } from './components/input-text/input-text.component';
import { NavPanelsComponent } from './components/nav-panels/nav-panels.component';
import { NavTabsComponent } from './components/nav-tabs/nav-tabs.component';
import { SidenavMenuComponent } from './components/sidenav-menu/sidenav-menu.component';
import { SimpleDropdownComponent } from './components/simple-dropdown/simple-dropdown.component';
import { SliderComponent } from './components/slider/slider.component';
import { SpeechTextRecorderComponent } from './components/speech-text-recorder/speech-text-recorder.component';
import { SwitchStatesComponent } from './components/switch-states/switch-states.component';
import { TextSpeechReaderComponent } from './components/text-speech-reader/text-speech-reader.component';
import { TinyBotSpinnerComponent } from './components/tiny-bot-spinner/tiny-bot-spinner.component';
// Directives
import { InputAutofocusDirective } from './directives/input-autofocus.directive';
import { InputDisabledFixDirective } from './directives/input-disabled-fix.directive';
import { InnerSidenavComponent } from './inner-sidenav/inner-sidenav.component';
import { ListButtonsSelectorComponent } from './list-buttons-selector/list-buttons-selector.component';

@NgModule({
  imports: [
    AccordionModule.forRoot(),
    BsDatepickerModule.forRoot(),
    AlertModule.forRoot(),
    BsDropdownModule,
    ColorPickerModule,
    CommonModule,
    DragDropModule,
    ExperimentalScrollingModule,
    FormsModule,
    PerfectScrollbarModule,
    PipesModule,
    ProtocolDroidModule,
    ReactiveFormsModule,
    RouterModule,
    ScrollingModule,
    SvgIconModule,
    TooltipModule.forRoot()
  ],
  declarations: [
    AlertWarningComponent,
    ButtonCopyComponent,
    DatePickerComponent,
    AvatarComponent,
    BadgeComponent,
    BadgeErrorsComponent,
    BadgeInfosComponent,
    ButtonFlashingComponent,
    ButtonIconComponent,
    ButtonRoundComponent,
    CaretComponent,
    ConversationDataComponent,
    ConversationDataListComponent,
    ConversationAiSourcesComponent,
    DataKeysBadgeComponent,
    DataKeysDropdownMenuListComponent,
    DataSingleValueSelectorComponent,
    FilterBadgeComponent,
    InnerSidenavComponent,
    InputAutofocusDirective,
    InputDisabledFixDirective,
    ListButtonsSelectorComponent,
    NavPanelsComponent,
    NavTabsComponent,
    SidenavMenuComponent,
    SimpleDropdownComponent,
    SliderComponent,
    SpeechTextRecorderComponent,
    TextSpeechReaderComponent,
    TinyBotSpinnerComponent,
    DataComparisonListComponent,
    DataComparisonTypeSelectorComponent,
    DataComparisonComponent,
    InputTextComponent,
    BoxDashComponent,
    HeaderAppDropdownComponent,
    SwitchStatesComponent,
    ConversationIntroComponent
  ],
  exports: [
    AccordionModule,
    AlertWarningComponent,
    AlertModule,
    AvatarComponent,
    BadgeComponent,
    BadgeErrorsComponent,
    BadgeInfosComponent,
    ButtonIconComponent,
    ButtonRoundComponent,
    BsDatepickerModule,
    ButtonCopyComponent,
    ButtonFlashingComponent,
    CaretComponent,
    ConversationDataComponent,
    DataKeysBadgeComponent,
    DataSingleValueSelectorComponent,
    DatePickerComponent,
    FilterBadgeComponent,
    InnerSidenavComponent,
    InputAutofocusDirective,
    InputDisabledFixDirective,
    ListButtonsSelectorComponent,
    NavPanelsComponent,
    RouterModule,
    SidenavMenuComponent,
    SliderComponent,
    SimpleDropdownComponent,
    SpeechTextRecorderComponent,
    SvgIconModule,
    TextSpeechReaderComponent,
    TinyBotSpinnerComponent,
    TooltipModule,
    DataComparisonListComponent,
    DataComparisonTypeSelectorComponent,
    DataComparisonComponent,
    InputTextComponent,
    BoxDashComponent,
    HeaderAppDropdownComponent,
    SwitchStatesComponent
  ]
})
export class UiElementsModule {}
